import * as types from '../../../actions/types';
import createReducer from '../../../../utils/createReducer';

const initialHotelsState = {
  maps: false,
  locations: [],
  details: false,
  hotel: null,
  header: {},
  popular: '',
  score: '',
  stars: '',
  budget: '',
  query: '',
  disabled: false
};

export const hotelsResultsReducer = createReducer(initialHotelsState, {
  [types.SHOW_MAPS](state, action) {
    let newState = Object.assign({}, state, {
      maps: action.maps,
      locations: action.locations
    });
    return newState;
  },
  [types.SHOW_DETAILS](state, action) {
    let newState = Object.assign({}, state, {
      details: action.details,
      hotel: action.hotel,
      header: action.header
    });
    return newState;
  },
  [types.SET_FILTERS](state, action) {
    let newState = Object.assign({}, state, action.filters);
    return newState;
  },
  [types.DISABLE_BUTTONS_RESULTS_HOTELS](state, action) {
    return { ...state, ...{ disabled: action.disabled } };
  }
});